import { useTranslation } from 'react-i18next';

import type { UserLanguage } from '~/api/user/types';

import { Field, Select } from '../Form';
import { itemStyle, triggerStyle } from './LanguageSelect.css';

type Props = {
  languages: UserLanguage[];
  onValueChange: (language: UserLanguage | null) => void;
  value: UserLanguage;
};

export const LanguageSelect = ({ languages, onValueChange, value }: Props) => {
  const { t } = useTranslation(['common']);

  const options = languages.map((language) => ({ label: language.toUpperCase(), value: language }));

  return (
    <Field.Root>
      <Select.Root items={options} onValueChange={onValueChange} value={value}>
        <Select.Button
          aria-label={t('common:languageSelector', { value: t(`common:languages.${value}`) })}
          className={triggerStyle}
          emphasis="tertiary"
        />

        <Select.List>
          {options.map(({ label, value }) => (
            <Select.Item aria-label={t(`common:languages.${value}`)} className={itemStyle} key={value} value={value}>
              {label}
            </Select.Item>
          ))}
        </Select.List>
      </Select.Root>
    </Field.Root>
  );
};
